import { Component, inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../environment/environment';
import { AnalyticsService } from './core/services/analytics.service';
import { isPlatformBrowser } from '@angular/common';
import { UtilityService } from './shared/services/utility.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'website';

  private platformId = inject(PLATFORM_ID);

  constructor(private router: Router, private analyticService: AnalyticsService, private utilityService: UtilityService) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && environment.production) {
      this.loadGA();
      this.initRouteTracking();
    }
    if (isPlatformBrowser(this.platformId)) {

      // this.utilityService.initializeCurrency();
    }
    // this.analyticService.init().then(() => {
    //   this.router.events
    //     .pipe(filter(e => e instanceof NavigationEnd))
    //     .subscribe((event: NavigationEnd) => {
    //       this.analyticService.sendPageView(event.urlAfterRedirects);
    //     });

    //   // send initial pageview for first load
    //   this.analyticService.sendPageView(window.location.pathname);
    // });

  }

  loadGA() {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GZV066T7YJ';
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-GZV066T7YJ');
  `;
    document.head.appendChild(inlineScript);
  }

  initRouteTracking() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

        if (typeof gtag === 'function') {
          gtag('config', 'G-GZV066T7YJ', {
            page_path: event.urlAfterRedirects
          });
        }

      });
  }
}
